import * as React from 'react';
import { Controller } from 'react-hook-form';

import { Row } from '../../../components/ui';
import { AvatarWrapper, FormWrapper, View } from './RegisterForm.style';
import { UploadMediaFile } from '../../components/media/UploadMediaFile';
import { RegisterFormContext } from './RegisterForm.context';
import { AvatarIconMan, AvatarIconWoman } from './RegisterForm.icon';
import { InputMaskStyled, InputStyled } from '../../elements/forms/InputContainer';

function RegisterFormStep1() {
  const {
    errors,
    control,
    setValue,
    getValues,
    step,
    isSubmitting,
    onHandleSubmit,
    verificandoEmail,
    token,
  } = React.useContext(RegisterFormContext);

  const [defaultAvatar] = React.useState<number>(Math.random());

  // O arquivo fica no formulario e sobe no submit final. Antes o passo subia a
  // foto para o S3 por um endpoint que exige sessao — em /register nao ha
  // nenhuma — e gravava a URL numa chave que o zod descartava.
  const receberAvatar = React.useCallback(
    (arquivo: File) => {
      if (!(arquivo instanceof File)) return;

      const anterior = getValues('avatar_preview');
      if (anterior) URL.revokeObjectURL(anterior);

      setValue('avatar', arquivo, {shouldValidate: false});
      setValue('avatar_preview', URL.createObjectURL(arquivo), {shouldValidate: false});
    },
    [getValues, setValue],
  );

  if (step !== 1) return null;

  return (
    <View>
      <h1>Comece agora a transformar sua carreira</h1>
      <FormWrapper onSubmit={onHandleSubmit}>
        <div>
          <AvatarWrapper>
            <UploadMediaFile
              setUploadFile={receberAvatar as never}
              mediaType="image"
              cropAspect={1}
              cropTitle="Ajustar foto de perfil">
              {defaultAvatar < 0.5 ? (
                <AvatarIconMan style={{opacity: 0.5, filter: 'grayscale(100%)'}} />
              ) : (
                <AvatarIconWoman style={{opacity: 0.5, filter: 'grayscale(100%)'}} />
              )}
            </UploadMediaFile>
            <Row>
              <span>
                Clique na imagem para escolher sua foto de perfil — a imagem profissional que será
                usada para divulgar seu trabalho
              </span>
            </Row>
          </AvatarWrapper>
        </div>

        <div className="form-inputs" style={{flex: 1}}>
          <Controller
            name="name"
            control={control}
            render={({field}) => (
              <InputStyled
                {...field}
                label="Nome e Sobrenome*"
                autoComplete="name"
                placeholder="Nome e Sobrenome"
                className={errors.name?.message ? 'invalid' : ''}
                error={errors.name?.message}
                s={12}
              />
            )}
          />

          <Controller
            name="email"
            control={control}
            render={({field}) => (
              <div className="input-field">
                <InputStyled
                  {...field}
                  label="Email*"
                  placeholder="Email"
                  type="email"
                  autoComplete="email"
                  className={errors.email?.message ? 'invalid' : ''}
                  error={errors.email?.message}
                  s={12}
                />
              </div>
            )}
          />

          <Controller
            name="phone"
            control={control}
            render={({field}) => (
              <div className="input-field">
                <InputMaskStyled
                  {...field}
                  type="tel"
                  placeholder="Celular"
                  label="Celular*"
                  mask="(99) 99999-9999"
                  error={errors.phone?.message}
                />
              </div>
            )}
          />

          {!token?.length && (
            <Controller
              name="password"
              control={control}
              render={({field}) => (
                <InputStyled
                  {...field}
                  placeholder="Crie sua senha"
                  label="Crie sua senha*"
                  type="password"
                  autoComplete="new-password"
                  className={errors.password?.message ? 'invalid' : ''}
                  error={errors.password?.message}
                />
              )}
            />
          )}

          <button
            className="btn btn-primary right"
            type="button"
            onClick={onHandleSubmit}
            disabled={isSubmitting || verificandoEmail}>
            {verificandoEmail ? 'Verificando...' : 'Continuar'}
          </button>
        </div>
      </FormWrapper>
    </View>
  );
}

export {RegisterFormStep1};
